import { render, staticRenderFns } from "./editorDialog.vue?vue&type=template&id=3fd64c46&scoped=true"
import script from "./editorDialog.vue?vue&type=script&lang=js"
export * from "./editorDialog.vue?vue&type=script&lang=js"
import style0 from "./editorDialog.vue?vue&type=style&index=0&id=3fd64c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd64c46",
  null
  
)

export default component.exports